import { useParams } from 'react-router-dom';

import { WhiteboardSessions } from './WhiteboardSessions';
import { getUrlParam } from '../../../utils/url';
import { WhiteboardProvider } from '../context/WhiteboardContext';

const WhiteboardSessionsPage: React.FC = () => {
    const { classUuid } = useParams<{ classUuid: string }>();
    const token = getUrlParam('token', true);
    const meetingId = getUrlParam('meeting_id', true);

    if (!token || !meetingId) {
        return <></>;
    }

    return (
        <WhiteboardProvider classUuid={classUuid} token={token} meetingId={meetingId}>
            <WhiteboardSessions />
        </WhiteboardProvider>
    );
};

export default WhiteboardSessionsPage;
